/* tslint:disable */
/* eslint-disable */
/**
 * Backoffice Microservice
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AcquiringAuditLogRequest
 */
export interface AcquiringAuditLogRequest {
    /**
     * 
     * @type {string}
     * @memberof AcquiringAuditLogRequest
     */
    id: string;
}

export function AcquiringAuditLogRequestFromJSON(json: any): AcquiringAuditLogRequest {
    return AcquiringAuditLogRequestFromJSONTyped(json, false);
}

export function AcquiringAuditLogRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): AcquiringAuditLogRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
    };
}

export function AcquiringAuditLogRequestToJSON(value?: AcquiringAuditLogRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
    };
}


